import lightUpPNG from '~/assets/images/communication/light-up.png'
import lightUpWEBP from '~/assets/images/communication/light-up.webp'
import RatingScalePage from '~/pages/communication/libs/RatingScalePage'
import { LIGHT_UP_QUESTION } from '~/pages/communication/lightUp/libs/components/LightUpCommunication/constants'
import { TPageProps } from '~/shared/types/commonTypes'

const LightUpCommunication = (props: TPageProps) => (
  <RatingScalePage
    {...props}
    question={LIGHT_UP_QUESTION}
    titleI18nKey="onboarding.communicationLightUp.title"
    subtitleI18nKey="onboarding.communicationLightUp.subtitle"
    labelWeakI18nKey="onboarding.communicationLightUp.labelWeak"
    labelPowerfulI18nKey="onboarding.communicationLightUp.labelPowerful"
    imagePng={lightUpPNG}
    imageWebp={lightUpWEBP}
    imageAlt="Some people light up a room without trying"
  />
)

export default LightUpCommunication
